module.exports = __webpack_public_path__ + "img/29.acd1f0f9.jpg";